import {AxiosError} from 'axios';
import {GET_NON_NATIONAL_EXAM_WITHDRAWAL_INSTRUCTION_QUERY_KEY} from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import {GET_NON_NATIONAL_EXAM_WITHDRAWAL_INSTRUCTION_URL} from '../../constants/apiUrls';
import {useCustomQuery} from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface WithdrawalInstructionDetails {
  uuid: string;
  applicationId: string;
  examLevel: string;
  isWithdrawOpen: boolean;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (data: WithdrawalInstructionDetails) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetNonNationalWithdrawalInstruction = ({onSuccess, onError}: Input = {}) => {
  const getNonNationalWithdrawalInstruction = async () => {
    const res = await axiosClient.get<WithdrawalInstructionDetails>(
        GET_NON_NATIONAL_EXAM_WITHDRAWAL_INSTRUCTION_URL
    );
    return res.data;
  };

  return useCustomQuery(
      GET_NON_NATIONAL_EXAM_WITHDRAWAL_INSTRUCTION_QUERY_KEY,
      getNonNationalWithdrawalInstruction,
      {
        onSuccess,
        onError,
      }
  );
};
